<template>
  <div>
    <div v-if="!showRegistrationForm || apiRegisterResponseError">
      <TText size="lg" tag="h1" variant="semibold" class="mb-4">
        {{ t('views.registration-traveler.title') }}
      </TText>
      <div v-if="apiRegisterResponseError" class="my-4">
        <ApiResponseError :api-response-error="apiRegisterResponseError" />
      </div>
      <div class="flex flex-col justify-center my-8">
        <UButton
          color="neutral"
          variant="subtle"
          icon="i-heroicons-envelope"
          size="lg"
          block
          class="my-3"
          @click="toggleEmailForm"
        >
          {{ t('auth.registrationTraveler.email.button') }}
        </UButton>
        <UButton
          color="neutral"
          variant="subtle"
          icon="i-logos-google-icon"
          size="lg"
          block
          class="my-3"
          :disabled="!isReady"
          @click="login()"
        >
          {{ t('auth.registrationTraveler.google.button') }}
        </UButton>
      </div>

      <div class="text-center text-sm">
        <slot />
      </div>
    </div>

    <div v-else>
      <AuthRegisterTravelerEmail
        v-if="showEmailForm"
        :is-modal="isModal"
        @login-success="isModal && emit('login-success')"
      />
      <AuthRegisterTravelerGoogle
        v-if="showGoogleForm && googleUserInfo"
        :user-info="googleUserInfo"
        :is-modal="isModal"
        @login-success="isModal && emit('login-success')"
      />

      <div class="flex flex-col items-center">
        <TText class="text-sm" classes="mb-3">{{
          t('auth.registrationTraveler.alternative')
        }}</TText>
        <UButton
          color="neutral"
          variant="subtle"
          size="lg"
          block
          class="my-3"
          @click="resetForms"
        >
          {{ t('auth.registrationTraveler.return') }}
        </UButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGoogleSignIn } from '~~/modules/auth/composables/useGoogleSignIn'

const props = defineProps<{
  isModal?: boolean
}>()

const emit = defineEmits(['login-success'])

const showEmailForm = ref<boolean>(false)

const showRegistrationForm = computed(
  () => showGoogleForm.value || showEmailForm.value,
)

const apiRegisterResponseError = computed(() => {
  return googleApiResponseError.value
})

const loginSuccess = computed(() => {
  return googleLoginSuccess.value
})

const toggleEmailForm = () => {
  showEmailForm.value = true
  showGoogleForm.value = false
}

const resetForms = () => {
  showEmailForm.value = false
  showGoogleForm.value = false
}

const {
  googleUserInfo,
  googleApiResponseError,
  showGoogleForm,
  googleLoginSuccess,
  onSuccessGoogleSignInRegister,
  onErrorGoogleSignIn,
} = useGoogleSignIn(props.isModal)

const { isReady, login } = useTokenClient({
  onSuccess: onSuccessGoogleSignInRegister,
  onError: onErrorGoogleSignIn,
})

watch(loginSuccess, () => {
  if (loginSuccess.value && props.isModal) {
    emit('login-success')
  }
})
</script>
